<template>
  <div v-if="program">
    <sticky class="page-header sticky-page-header page-header--new" :back-button="true">
      <span slot="left-title">Fiche programme <router-link :to="{name: 'ProgramVue', params: {id: program.pk}}" v-if="program">({{program.name}})</router-link></span>
    </sticky>
    <!-- <div class="columns is-gapless is-padding-top is-padding-left-on-btn-actions">
      <div class="column is-10 is-9-widescreen is-8-fullhd">
        <div class="has-bg-white is-border"> -->
    <div class="is-padding-top is-padding-left-on-btn-actions is-padding-right-on-btn-actions">
      <program-form v-if="program"
                  ref="programForm"
                  @submit="submit"
                  :program="program"
                  :loading="submitting"
                  :select-panel="selectPanel"
      ></program-form>
    </div>
        <!-- </div>
      </div> -->
      <!-- <div class="column is-3 is-2-widescreen">
        <div class="is-border is-radius-large" v-if="helperTitle || helperText">
          <div class="columns is-column is-border-bottom">
            <div class="column has-bg-light-darken-1 is-size-4">
              <b>Le saviez-vous ?</b>
            </div>
            <div class="column has-text-grey">
              <p><b>{{helperTitle}}</b></p>
              <p class="is-margin-top-small" style="white-space: pre-wrap;">{{helperText}}</p>
            </div>
          </div>
        </div>
      </div> -->
    <!-- </div> -->
  </div>
  <spinner-round v-else :isLoading="loading"></spinner-round>
</template>

<script>
  import ProgramForm from '@/components/program/ProgramForm'

  export default {
    name: 'ProgramEdit',
    data () {
      return {
        loading: true,
        submitting: false,
        program: null,
        helperTitle: null,
        helperText: null,
        selectPanel: null,
        returnAdv: false
      }
    },
    components: {
      ProgramForm
    },
    methods: {
      getProgram (id) {
        this.loading = true
        this.$api.programService.getOne(id).then(res => {
          this.loading = false
          this.program = res.data
        }).catch(() => {
          this.loading = false
        })
      },
      submit (program, isNew, hasChanged, reload = true, to) {
        if (typeof reload !== 'boolean') {
          reload = true
        }
        console.log(hasChanged)
        const currentPanel = this.$refs.programForm.panel
        console.log(this.$refs.programForm)
        this.submitting = true
        let data = Object.assign({}, program)
        if (hasChanged) {
          data.adf_updated = true
        }
        this.$api.programService.put(data.pk, data).then(res => {
          this.submitting = false
          this.$notify({
            type: 'is-success',
            text: 'Le programme a bien été mis à jour'
          })
          if (this.returnAdv) {
            return this.$router.goBack(this.$route)
          } else if (reload) {
            return this.$router.replace({name: 'ProgramVue', params: {id: res.data.pk}})
          } else {
            // Little trick to update the programform component and go back to the previous panel
            this.program = null
            return this.$nextTick(() => {
              this.program = res.data
              this.$nextTick(() => {
                this.$refs.programForm.panel = currentPanel
              })
            })
          }
        }).catch(() => {
          this.submitting = false
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de la mise à jour du programme.'
          })
        })
      },
      getHelper () {
        if (this.$contentful) {
          this.$contentful.getEntry('8iImr9sPNmoM8KUImoMA4').then(entry => {
            this.helperTitle = entry.fields.title
            this.helperText = entry.fields.text
          })
        }
      }
    },
    created () {
      this.getProgram(this.$route.params.id)
      if (this.$route.query && this.$route.query.panel) {
        this.selectPanel = this.$route.query.panel
      }
      if (this.$route.query && this.$route.query.returnAdv) {
        this.returnAdv = true
      }
    },
    mounted () {
      this.getHelper()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/program/ProgramEdit.vue